const view = "login_and_signup";

export const EVENTS = {
  showCreateAccount: {
    view,
    event: "show_create_account_clicked",
  },
  alreadyRegistered: {
    view,
    event: "already_registered_clicked",
  },
  viewEntitlementsOnWellnessLanding: {
    view,
    event: "view_entitlements_on_wellness_landing_clicked",
  },
  viewTermsAndConditionsOnWellnessLanding: {
    view,
    event: "view_terms_and_conditions_on_wellness_landing_clicked",
  },
};
